// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React from 'react';

// Long generated file names break at underscores first; the row style's overflow-wrap covers names without any
const wrapAtUnderscores = (name = '') => {
  let prefix = '';
  return name.split('_').map((part, idx) => {
    const segment = idx === 0 ? part : `_${part}`;
    prefix += segment;
    return (
      <React.Fragment key={prefix}>
        {idx > 0 && <wbr />}
        {segment}
      </React.Fragment>
    );
  });
};

export default wrapAtUnderscores;
